export interface ClassTimeRange {
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
}

// A class already on the batch calendar, for the tutor clash check
export interface BookedClass extends ClassTimeRange {
  title: string;
  tutor: string;
}

function toRange(range: ClassTimeRange): { start: Date; end: Date } {
  const start = range.startTime
    ? new Date(`${range.startDate}T${range.startTime}`)
    : new Date(`${range.startDate}T00:00:00`);
  const end = range.endTime
    ? new Date(`${range.endDate}T${range.endTime}`)
    : new Date(`${range.endDate}T23:59:59`);
  return { start, end };
}

export function rangesOverlap(a: ClassTimeRange, b: ClassTimeRange): boolean {
  const rangeA = toRange(a);
  const rangeB = toRange(b);
  return rangeA.start < rangeB.end && rangeB.start < rangeA.end;
}

export function findOverlappingClass(
  candidate: ClassTimeRange & { tutor: string },
  existing: BookedClass[]
): BookedClass | undefined {
  const tutor = candidate.tutor.trim().toLowerCase();
  if (!tutor) {
    return undefined;
  }
  return existing.find(
    (booked) =>
      booked.tutor.trim().toLowerCase() === tutor &&
      rangesOverlap(booked, candidate)
  );
}
